import { Product } from 'state/product'
import { Color } from 'state/color'

MK.events.on('products:activate:all', (event = {}) => {
  Object.values(Product.index.ids).forEach(product => {
    product.color.id = product.color.default
    product.is.active = true
  })

  for (let alias in Color.by.alias) {
    Color.by.alias[alias].is.active = true
  }

  if (!window.MK.page.ids.group) {
    MK.events.emit('products:updateDOM', {
      initiator: 'products:activate:all'
    })
  }
})